import { FormBuilder } from '@angular/forms';
import { HelpersService } from '../../../core/services/helpers.service';
import { OperationsService } from '../../../core/services/operations.service';
import { MotivoScadenzaAuto } from '../../models/tipologiche/motivo-scadenza-auto';
import { Priorita } from '../../models/tipologiche/priorita';
import { TipoScadenza } from '../../models/tipologiche/tipo-scadenza';
import { BaseForm } from '../base-Form';

declare var removeEmptyObject: any;

export abstract class ScadenzarioAutoAddFormComponent extends BaseForm {

    tipoScadenzaOptions: TipoScadenza[] = [];
    motivoScadenzaOptions: MotivoScadenzaAuto[] = [];
    prioritaOptions: Priorita[] = [];

    constructor(protected operationService: OperationsService, protected campiForm: FormBuilder, private helpers: HelpersService) {
        super();
    }

    populateSelect() {
        if (this.tipoScadenzaOptions.length === 0) {
            this.helpers.getTipiScadenza().subscribe(response => this.tipoScadenzaOptions = response);
        }
        if (this.motivoScadenzaOptions.length === 0) {
            this.helpers.getMotiviScadenzaAutomatica().subscribe(response => this.motivoScadenzaOptions = response);
        }
        if (this.prioritaOptions.length === 0) {
            this.helpers.getPrioritaScadenza().subscribe(response => this.prioritaOptions = response);
        }
    }
}
